function RosterPanel() {

}

RosterPanel.availableSizes = [
    {
        category: 'adult',
        sizes: ['S', 'M', 'L', 'XL', '2XL', '3XL']
    },
    {
        category: 'youth',
        sizes: ['YXS', 'YS', 'YM', 'YL', 'YXL']
    }
];

RosterPanel.sizeOrder = {
    items: [
        {
            "size": "YXS",
            "order": 1
        },
        {
            "size": "YS",
            "order": 2
        },
        {
            "size": "YM",
            "order": 3
        },
        {
            "size": "YL",
            "order": 4
        },
        {
            "size": "YXL",
            "order": 5
        },
        {
            "size": "S",
            "order": 6
        },
        {
            "size": "M",
            "order": 7
        },
        {
            "size": "L",
            "order": 8
        },
        {
            "size": "XL",
            "order": 9
        },
        {
            "size": "2XL",
            "order": 10
        },
        {
            "size": "3XL",
            "order": 11
        },
        {
            "size": "3-5 (S)",
            "order": 1
        },
        {
            "size": "5-7 (M)",
            "order": 2
        },
        {
            "size": "8-12 (L)",
            "order": 3
        },
        {
            "size": "13-14 (XL)",
            "order": 4
        }
    ],

    findOrder: function(size) {
        return _.find(this.items, {size: size});
    }
};

RosterPanel.availableSizesSocks = [
    {
        size: '3-5 (S)',
        cart: "S"
    },
    {
        size: '5-7 (M)',
        cart: "M"
    },
    {
        size: '8-12 (L)',
        cart: "L"
    },
    {
        size: '13-14 (XL)',
        cart: "XL"
    }
];

RosterPanel.currentApplicationCode;
RosterPanel.vectorDropzone;

RosterPanel.events = {
    isInit: true,
    isInitDropzone: true,

    init: function() {
        var that = this;
        if (that.isInit) {
            $("#right-pane-column").on("click", ".richardson-footer .manage-team-roster", that.onClickManageRoster);
            $("#richardson-team-roster").on("click", ".uniform-size-button", that.onClickUniformSize);
            $("#richardson-team-roster").on("click", ".player-number-button", that.onClickPlayerNumber);
            // Edit Roster
            $("#richardson-team-roster").on("keypress", ".roster-uniform-name, .roster-uniform-last-name, .roster-uniform-number, .roster-uniform-qty", _.debounce(that.onUpdateRosterInfo, 500));
            $("#richardson-team-roster").on("blur mouseup", ".roster-uniform-name, .roster-uniform-last-name, .roster-uniform-number, .roster-uniform-qty", that.onUpdateRosterInfo);
            $("#richardson-team-roster").on("change", "select.roster-inseam", that.onChangeInseam);
            $("#richardson-team-roster").on("click", ".remove-player-info", that.onRemoveRoster);
            $("#richardson-team-roster").on("change", "input.roster-uniform-tag-id", that.onSaveTagId);

            $("#richardson-team-roster").on("click", ".save-roster", that.onClickSaveRoster);
            $("#richardson-team-roster").on("click", ".click-player-number", that.onClickSummaryPlayerNumber);
            $("#richardson-team-roster").on('click', '.add-player', that.onAddPlayer);

            $("#richardson-team-roster").on("change", ".application-sizing-container .application-sizing-item select", that.onChangeSize)
            $("#richardson-team-roster").on("click", ".application-sizing-container .application-sizing-item .application-size-type", that.onChangeApplicationSizeType);
            
            $("#richardson-team-roster").on("change", ".application-sizing-container .application-sizing-item textarea.app-notes", that.onSaveApplicationNotes);
            $("#richardson-team-roster").on("keypress", ".application-sizing-container .application-sizing-item textarea.app-notes", that.onKeyPressNotes);

            $("#richardson-team-roster").on("click", ".application-sizing-container .save-application-sizing", function() {
                var message = "Application sizes successfully saved.";
                ub.utilities.notifyMe(message, "success");
                ub.data.rosterIsChange = true;
            });

            $("#richardson-team-roster").on("click", ".application-sizing-container .upload-vector-modal", that.onOpenUploadVector);
            $("#richardson-team-roster").on("click", ".application-sizing-container .remove-vector-file", that.onRemoveVector);

            $("#richardson-team-roster").on("click", ".application-size-tab", function() {
                if (RichardsonOrderEditor.isCompleted()) {
                    return
                } else {
                    that.onClickSaveRoster();
                } 
            });

            that.isInit = false;
        }
    },
    // Show roster
    onShowRoster: function() {
        RosterPanel.events.renderRosterContent();
        RosterPanel.events.prepareUniformSizes();
        RosterPanel.events.preparePlayerNumbers();
        RosterPanel.events.prepareApplicationSizing();
        RosterPanel.events.prepareRosterSummary();
        RosterPanel.events.onHoverPlayerNumberActive();

        // Roster Upload Binding Events
        RosterUpload.events.init();

        // Switch Primary Tabs
        UIkit.switcher("#richardson-team-roster .active-bgc-red-switcher").show(0);
        UIkit.switcher(".roster-menu").show(0);

        // Show modal
        UIkit.modal("#richardson-team-roster").show();
    
        // Disable ROster Function
        RichardsonOrderEditor.statusChecker(RosterPanel.lockFunction, 500);

        _.delay(function() {
            $("#property-modifiers-menu .menu-item").first().trigger("click");
        }, 200)
    },

    onSaveTagId: function() {
        var container = $(this).closest(".player-info")
        var tagid = $(this).val();
        var size = container.find(".roster-uniform-size").val();
        var category = container.data("category");
        var index = $(this).closest('tr').index();

        var roster = RosterPanel.events.find(size, category);
        if (typeof roster !== "undefined") {
            var info = roster.rosters[index];
            if (typeof info !== "undefined") {
                info.tagid = tagid;
            }
        }
    },

    onChangeInseam: function() {
        var container = $(this).closest(".player-info")
        var inseam = $(this).val();
        var size = container.find(".roster-uniform-size").val();
        var category = container.data("category");
        var index = $(this).closest('tr').index();

        var roster = RosterPanel.events.find(size, category);
        if (typeof roster !== "undefined") {
            var info = roster.rosters[index];
            if (typeof info !== "undefined") {
                info.inseam = inseam;
            }
        }

        RosterPanel.events.setupRosterListingSummary(size, category);
    },

    onAddPlayer: function(isAdd = true) {
        var active_size = $("#richardson-team-roster .uniform-size-button.uk-active").data("size");

        if (typeof active_size === "undefined") {
            return;
        }
        var category = $("#richardson-team-roster .uniform-size-button.uk-active").data("category");
        if (isAdd) {
            var numbers = [];

            numbers.push({
                size: active_size,
                number: "",
                qty: 1,
                lastName: "",
                category: category,
                inseam: ub.funcs.isBaseBall() && ub.funcs.is_lower() ? "standard" : "",
                tagid: ""
            });
        }

        $("#richardson-team-roster .uniform-size-button[data-size='"+  active_size +"'][data-category='"+  category +"']").addClass("selected");

        RosterPanel.events.saveRosterData(active_size, category, numbers);
        var roster = RosterPanel.events.find(active_size, category);
        RosterPanel.events.prepareRosterList(roster.rosters);
        RosterPanel.events.prepareRosterSummary();
    },

    onClickManageRoster: function() {
        $("#property-modifiers-menu .menu-item-roster").trigger("click");
    },

    onHoverPlayerNumber: function() {
        var active_size = $("#richardson-team-roster .uniform-size-button.uk-active").data("size");
        var category = $("#richardson-team-roster .uniform-size-button.uk-active").data("category");
        var number = $(this).data("number");
    },

    onClickPlayerNumber: function() {
        var active_size = $("#richardson-team-roster .uniform-size-button.uk-active").data("size");
        var category = $("#richardson-team-roster .uniform-size-button.uk-active").data("category");
        var number = $(this).data("number");

        if (number === "none") {
            RosterPanel.events.onAddPlayer();
            return;
        }

        if ($(this).hasClass("selected")) {
            return;
        }
        var numbers = [];

        $("#richardson-team-roster .uniform-size-button[data-size='"+  active_size +"'][data-category='"+  category +"']").addClass("selected");

        if ($("#richardson-team-roster .uniform-size-button.uk-active").length > 0) {
            if ($(this).hasClass("uk-active")) {
                $("#richardson-team-roster .remove-player-info[data-number='"+ number +"'][data-category='"+ category +"']").trigger("click");
                $(this).removeClass("uk-active");
            } else {
                var findNumber = _.find(ub.data.playerNumbers, {number: number.toString()});
                if (typeof findNumber !== "undefined") {
                    numbers.push({
                        size: active_size,
                        number: $(this).data("number").toString(),
                        qty: 1,
                        lastName: "",
                        category: category
                    });
                }

                ub.funcs.setNumberStatus(active_size, category, $(this).data("number"), 'selected');
                $(this).addClass("uk-active");
                $(this).attr("data-size", active_size);
                $(this).attr("data-category", category);
            }
        } else {
            return;
        }

        RosterPanel.events.saveRosterData(active_size, category, numbers);
        var roster = RosterPanel.events.find(active_size, category);
        RosterPanel.events.prepareRosterList(roster.rosters);
        RosterPanel.events.prepareRosterSummary();
        RosterPanel.events.onHoverPlayerNumberActive();
    },

    //On Click Uniform Size
    onClickUniformSize: function() {
        if (ub.funcs.isLower() && ub.funcs.isBaseBall()) {
            if ($(this).hasClass("selected")) {
                if ($(this).hasClass("uk-active")) {
                    RosterPanel.events.onAddPlayer();
                } else {
                    $(".roster-uniform-size-container .uniform-size-button.uk-active").removeClass("uk-active");
                    $(this).addClass("uk-active");

                    var active_size = $(this).data("size");
                    var category = $(this).data("category");
                    // Initialize roster
                    RosterPanel.events.initializeRosterSummary(active_size, category);
                }
            } else {
                $(".roster-uniform-size-container .uniform-size-button.uk-active").removeClass("uk-active");
                $(this).addClass("uk-active");
                RosterPanel.events.onAddPlayer();
            }
        } else if(ub.funcs.is_pts_sock()){
            if ($(this).hasClass("selected")) {
                if ($(this).hasClass("uk-active")) {
                    RosterPanel.events.onAddPlayer(false);
                } else {
                    $(".roster-uniform-size-container .uniform-size-button.uk-active").removeClass("uk-active");
                    $(this).addClass("uk-active");

                    var active_size = $(this).data("size");
                    var category = $(this).data("category");
                    // Initialize roster
                    RosterPanel.events.initializeRosterSummary(active_size, category);
                }
            } else {
                $(".roster-uniform-size-container .uniform-size-button.uk-active").removeClass("uk-active");
                $(this).addClass("uk-active");
                RosterPanel.events.onAddPlayer();
            }
        } else {
            var size = $(this).data("size");
            var category = $(this).data("category");
            $(".roster-uniform-size-container .uniform-size-button.uk-active").removeClass("uk-active");
            $(this).addClass("uk-active");
            RosterPanel.events.preparePlayerNumbers(size, category);

            var roster = RosterPanel.events.find(size, category);
            if (typeof roster !== "undefined") {
                _.delay(function() {
                    _.each(roster.rosters, function(roster) {
                        $("#richardson-team-roster .player-number-button[data-number='"+ roster.number +"']").removeClass("selected").addClass("uk-active");
                    });
                }, 100);

                RosterPanel.events.prepareRosterList(roster.rosters);
            } else {
                $("#richardson-team-roster .roster-player-list-table tbody").html("");
            }

            RosterPanel.events.onHoverPlayerNumberActive();
        }
    },

    onClickSaveRoster: function() {
        var data = [];
        var _factoryCode = ub.current_material.material.factory_code;
        var _total = 0;
        var _prepareSize = [];
        var sockSizing = [];
        ub.current_material.settings.roster = [];
        ub.current_material.settings.size_breakdown = [];

        _.each(RosterPanel.teamRoster, function(roster) {
            if (roster.rosters.length > 0) {
                _.each(roster.rosters, function(item, index) {
                    ub.current_material.settings.roster.push({
                        index: index,
                        tagid: typeof item.tagid === "undefined" ? "" : item.tagid,
                        lastname: item.lastName ?? "",
                        size: item.size,
                        number: item.number.length === 0 ? "" : item.number,
                        // Disable temporarily for FOOTBALL
                        sleeveType: "N/A",
                        lastNameApplication: "",
                        Sample: 0,
                        quantity: item.qty,
                        inseam: typeof item.inseam === "undefined" ? "" : item.inseam
                    });

                    _total += parseInt(item.qty);

                    var _obj = _.find(_prepareSize, {size: item.size});

                    if (typeof _obj === "undefined") {
                        _prepareSize.push({size: item.size, quantity: 0 });
                        _obj = _.find(_prepareSize, {size: item.size});
                    }

                    _obj.quantity +=  parseInt(item.qty);
                    
                    if (ub.funcs.is_pts_sock()) {
                        var size = _.find(RosterPanel.availableSizesSocks, {size: item.size});
                        // CHECK IF SIZE is Existing
                        if (typeof size !== "undefined") {
                            var _obj = _.find(sockSizing, {size: size.cart});

                            if (typeof _obj === "undefined") {
                                sockSizing.push({size: size.cart, quantity: 0 });
                                _obj = _.find(sockSizing, {size: size.cart});
                            }

                            _obj.quantity +=  parseInt(item.qty);
                        }
                    }
                });

                if (ub.funcs.is_pts_sock()) {
                    ub.current_material.settings.sockSizing = sockSizing;
                }
                
                ub.current_material.settings.size_breakdown = _prepareSize;
            }
        });

        ub.current_material.settings.teamRoster = RosterPanel.teamRoster;
        ub.data.rosterIsChange = true;

        if (_.size(ub.current_material.settings.roster) === 0) {
            UIkit.notification.closeAll()
            // Notification
            var message = "Roster is still empty. Please add item in the roster.";
            ub.utilities.notifyMe(message, "primary", 3000);
        } else {
            UIkit.notification.closeAll()
            // Notification
            var message = "Roster successfully saved.";
            ub.utilities.notifyMe(message, "success");
        }
        
        UIkit.switcher("#richardson-team-roster .active-bgc-red-switcher").show(1);
    },

    onClickSummaryPlayerNumber: function() {
        var size = $(this).data("size")
        var number = $(this).data("number")
        var category = $(this).data("category")

        var uniform_size = $("#richardson-team-roster .uniform-size-button[data-size='"+ size +"'][data-category='"+ category +"']");
        if (!uniform_size.hasClass("uk-active")) {
            uniform_size.trigger("click");
        }

        _.delay(function() {
            $(".roster-player-list-table .player-info").removeClass("active");
            $(".roster-player-list-table .player-info[data-size='"+ size +"'][data-category='"+ category +"'][data-number='"+ number +"']").addClass("active");
            $(".roster-player-list-table").parent().scrollTo("tr.player-number-" + number, { duration: 100 });
        }, 50)
    },

    onRemoveRoster: function() {
        var container = $(this).closest(".player-info")
        var size = container.find(".roster-uniform-size").val();
        var last_name = container.find(".roster-uniform-name").val();
        var number = container.find(".roster-uniform-number").val();
        var quantity = container.find(".roster-uniform-qty").val();
        var category = container.data("category");
        var index = $(this).closest('tr').index();

        var roster = RosterPanel.events.find(size, category);
        if (typeof roster !== "undefined") {
            var list = roster.rosters;
            if (typeof list !== "undefined") {
                list.splice(index, 1);

                // When the list reach 0 remove class selected.
                if (_.size(list) <= 0) {
                    $("#richardson-team-roster .uniform-size-button[data-size='"+ size +"']").removeClass("selected");
                }
            }
        }

        container.remove();

        $(".player-numbers-container .player-number-button[data-number='"+ number +"']").removeClass("selected").removeClass("uk-active");

        if (typeof number !== "undefined"){
            ub.funcs.setNumberStatus(undefined, undefined, number, 'free');
        }

        RosterPanel.events.prepareRosterSummary();
    },

    onUpdateRosterInfo: function() {
        if ($(this).hasClass('roster-uniform-qty')) {
            var value = $(this).val();
            if (value.startsWith("0") || value.length === 0) {
                $(this).val(1);
            }
        }

        var container = $(this).closest(".player-info")
        var size = container.find(".roster-uniform-size").val();
        var last_name = container.find(".roster-uniform-name").val();
        var number = container.find(".roster-uniform-number").val();
        var quantity = container.find(".roster-uniform-qty").val();
        var category = container.data("category");
        var index = $(this).closest('tr').index();

        if (typeof number !== "undefined"){
            if (number.length !== 0) {
                container.removeClass("player-number-");
                container.addClass("player-number-" + number);
                container.attr("data-number", parseInt(number));
            }
        }

        RosterPanel.events.updateRoster(size, last_name, number, quantity, category, index);
    },

    // Application Sizing Events
    onChangeApplicationSizeType: function() {
        var code = $(this).closest(".application-sizing-item").data("code");
        var type = $(this).val();

        var settingsObject = ub.funcs.getApplicationSettings(code);
        if (typeof settingsObject !== "undefined") {
            settingsObject.size_type = type;
        }

        var sizingObject = RosterPanel.events.getApplicationSizingObject(code);
        if (typeof sizingObject !== "undefined") {
            sizingObject.size_type = type;
        }
    },

    onSaveApplicationNotes: function() {
        var code = $(this).closest(".application-sizing-item").data("code");
        var notes = $(this).val();

        var settingsObject = ub.funcs.getApplicationSettings(code);
        if (typeof settingsObject !== "undefined") {
            settingsObject.notes = notes;
        }

        var sizingObject = RosterPanel.events.getApplicationSizingObject(code);
        if (typeof sizingObject !== "undefined") {
            sizingObject.notes = notes;
        }
    },

    onKeyPressNotes: function(event) {
        var ENTER = 13;
        if (event.keyCode === ENTER) {
            $(this).blur();
        }
    },

    onChangeSize: function () {
        var code = $(this).closest(".application-sizing-item").data("code");
        var size = $(this).val();

        var settingsObject = ub.funcs.getApplicationSettings(code);
        if (typeof settingsObject !== "undefined") {
            settingsObject.application_size = size;
        }

        var sizingObject = RosterPanel.events.getApplicationSizingObject(code);
        if (typeof sizingObject !== "undefined") {
            sizingObject.application_size = size;
        }

        if (size !== "as_shown") {
            if ($(this).closest(".application-sizing-item").find(".application-size-type-container").hasClass("uk-hidden")) {
                $(this).closest(".application-sizing-item").find(".application-size-type-container").removeClass("uk-hidden");
            }
        } else {
            if (!$(this).closest(".application-sizing-item").find(".application-size-type-container").hasClass("uk-hidden")) {
                $(this).closest(".application-sizing-item").find(".application-size-type-container").addClass("uk-hidden");
            }
        }
    },

    onOpenUploadVector: function() {
        RosterPanel.currentApplicationCode = $(this).closest(".application-sizing-item").data("code");

        if (RosterPanel.events.isInitDropzone) {
            RosterPanel.vectorDropzone = new Dropzone('#vectorfile-dropzone', {
                url: ub.config.api_host + "/api/fileUpload",
                maxFiles: 1,
                uploadMultiple: false,
                addRemoveLinks: false,
                acceptedFiles: ".jpg, .jpeg, .png, .bmp, .svg",
                dictDefaultMessage: 'Click / Drop file here to upload a vector. *Transparent background is preferable',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                    'accessToken': null
                },
                init: function() {
                    this.on("maxfilesexceeded", function(file){
                        this.removeFile(file);
                        UIkit.notification({
                            message: "Only one image file is required",
                            status: 'danger',
                            pos: 'top-right',
                            timeout: 5000
                        });
                    });
                }
            });

            RosterPanel.vectorDropzone.on('success', function(file) {
                var response = JSON.parse(file.xhr.response);
                

                if (response.success) {
                    var applicationSettings = ub.funcs.getApplicationSettings(RosterPanel.currentApplicationCode);
                    var file_url = response.filename;
                    var filename = file.name;

                    if (typeof applicationSettings !== "undefined") {
                        var element = $("tr.application-sizing-item[data-code='"+ applicationSettings.code +"'] td.vector-upload-container");
                        // Bind application
                        applicationSettings.vector_file = {
                            filename: filename,
                            file_url: file_url
                        };
                        
                        RosterPanel.renderVectorPreview(element, file_url, filename);
                    }
                } else {
                    this.removeFile(file);
                    UIkit.notification({
                        message: "Failed to upload image",
                        status: 'danger',
                        pos: 'top-right',
                        timeout: 5000
                    });
                }
            });

            RosterPanel.events.isInitDropzone = false;
        }

        RosterPanel.vectorDropzone.removeAllFiles();
        
        UIkit.modal("#upload-vector-file", {stack: true}).show();
    },

    onRemoveVector: function() {
        var code = $(this).closest(".application-sizing-item").data("code");
        var element = ("tr.application-sizing-item[data-code='"+ code +"'] td.vector-upload-container");
        UIkit.modal.confirm('Are you sure you would like to remove the uploaded vector ?', {stack: true}).then(function() {
            var applicationSettings = ub.funcs.getApplicationSettings(code);
            if (typeof applicationSettings !== "undefined") {
                RosterPanel.renderUploadVector(element);
                delete applicationSettings.vector_file;
            }
        });
    },

    prepareUniformSizes: function() {
        var data = {
            uniformSizes: [],
            socksSizes: [],
            isPant: ub.funcs.isBaseBall() && ub.funcs.is_lower() ? true : false,
            isSock: ub.funcs.is_pts_sock() ? true : false
        }

        RosterPanel.events.initializeRosterSizes(data);

        var template = document.getElementById("m-richardson-roster-sizes").innerHTML;
        var render = Mustache.render(template, data);

        $("#richardson-team-roster .roster-uniform-size-container").html("");
        $("#richardson-team-roster .roster-uniform-size-container").html(render);

        var rosters = RosterPanel.teamRoster;

        if (rosters.length > 0) {
            _.map(rosters, function(roster) {
                if (roster.rosters.length > 0) {
                    $("#richardson-team-roster .uniform-size-button[data-size='"+ roster.size +"'][data-category='"+ roster.category +"']").addClass("selected");
                }
            });

            $("#richardson-team-roster .uniform-size-button.selected").first().trigger("click");
        }
    },

    preparePlayerNumbers: function(size, category) {
        var template = document.getElementById("m-richardson-roster-player-number").innerHTML;
        var render = Mustache.render(template, {
            numbers: ub.data.playerNumbers,
            size: size
        });

        $("#richardson-team-roster .player-numbers-container").html("");
        $("#richardson-team-roster .player-numbers-container").html(render);
    },

    prepareRosterList: function(numbers) {
        var template;

        if (ub.funcs.isBaseBall() && ub.funcs.is_lower()) {
            template = document.getElementById("m-richardson-pant-roster").innerHTML;
        } else if (ub.funcs.is_pts_sock()) {
            template = document.getElementById("m-richardson-sock-roster").innerHTML;
        } else {
            template = document.getElementById("m-richardson-apparel-roster").innerHTML;
        }

        var render = Mustache.render(template, {
            players: numbers
        });

        $("#richardson-team-roster .roster-player-list-table").html("");
        $("#richardson-team-roster .roster-player-list-table").html(render);

        var container = $("#richardson-team-roster .roster-player-list-table");
        _.delay(function() {
            _.each(numbers, function(number, index) {
                var tr = container.find("tr.player-info[data-category='"+ number.category +"'][data-size='"+ number.size +"']");
                $(tr[index]).find("select.roster-inseam option[value='"+ number.inseam +"']").prop("selected", true);
            });
        }, 100);
    },

    prepareRosterSummary: function() {
        var _this = this;
        if (ub.funcs.isBaseBall() && ub.funcs.is_lower()) {
            _this.renderSummaryRosterPants();
        }else if(ub.funcs.is_pts_sock()){
            _this.renderSummaryRosterSocks();
        }else {
            _this.renderSummaryRosterJersey();
        }
    },

    renderRosterContent() {
        if (ub.funcs.isBaseBall() && ub.funcs.is_lower()) {
            template = document.getElementById("lower-roster-template").innerHTML;
        } else if (ub.funcs.is_pts_sock()) {
            template = document.getElementById("socks-roster-template").innerHTML;
        } else {
            template = document.getElementById("upper-roster-template").innerHTML;
        }

        var render = Mustache.render(template);

        $("#richardson-team-roster ul#roster-content .roster-main").html("");
        $("#richardson-team-roster ul#roster-content .roster-main").html(render);
    },

    saveRosterData: function (size, category, rosters) {
        var find = this.find(size, category);
        var arrangement = RosterPanel.sizeOrder.findOrder(size);
        
        if (typeof find !== "undefined") {
            if (typeof rosters !== "undefined") {
                _.each(rosters, function(item) {
                    if (item.number.length === 0) {
                        find.rosters.push(item);
                    } else {
                        var isPresent = _.find(find.rosters, {size: item.size, number: item.number.toString(), category: item.category});
                        if (typeof isPresent === "undefined") {
                            find.rosters.push(item);
                        }
                    }
                });
            } else {
                var isPresent = _.find(find.rosters, {size: size});
                if (typeof isPresent !== "undefined") {
                    var qty = parseInt(isPresent.qty)
                    qty += 1;
                    if (qty <= 999) {
                        isPresent.qty = qty;
                    }
                }
            }
        } else {
            RosterPanel.teamRoster.push({
                size: size,
                category: category,
                rosters: rosters,
                order: typeof arrangement !== "undefined" ? arrangement.order : _.size(RosterPanel.availableSizes)
            });
        }
    },

    find: function (size, category) {
        return _.find(RosterPanel.teamRoster, {size: size, category: category});
    },

    updateRoster: function(size, last_name, number, quantity, category, index = undefined) {
        var roster = this.find(size, category);
        if (typeof roster !== "undefined") {
            if (typeof index !== "undefined") {
                var info = roster.rosters[index];
                if (typeof info !== "undefined") {
                    info.number = typeof number !== "undefined" ? number.toString() : "";
                    info.qty = quantity.length === 0 ? 0 : quantity;
                    info.lastName = last_name;
                }
            } else {
                var info = _.find(roster.rosters, {size: size, number: number.toString()});
                if (typeof info !== "undefined") {
                    info.number = number.toString();
                    info.qty = quantity.length === 0 ? 0 : quantity;
                    info.lastName = last_name;
                }
            }
        }

        this.setupRosterListingSummary(size, category);
    },

    onHoverPlayerNumberActive: function() {
        $("#richardson-team-roster .player-number-button").unbind("hover");
        $("#richardson-team-roster .player-number-button").hover(function() {
            var number = $(this).data("number");
            var active_size = $(".roster-uniform-size-container .uniform-size-button.uk-active").data("size");
            var category = $(".roster-uniform-size-container .uniform-size-button.uk-active").data("category");
            var html =  "";
            var info;

            if ($(this).hasClass("uk-active") || $(this).hasClass("selected")) {
                var roster = RosterPanel.events.find(active_size, category);
                if (typeof roster !== "undefined") {
                        info = _.find(roster.rosters, {size: active_size, number: number.toString()});
                    if (typeof info !== "undefined") {
                        html = "NO. " + info.number + " - " + info.size + ' - ' + info.qty + " pcs" + " - " + info.lastName;
                    }
                }

                $("#richardson-team-roster .player-info-preview").html("");
                $("#richardson-team-roster .player-info-preview").html(html);
            }
        }, function() {
            $("#richardson-team-roster .player-info-preview").html("");
        });
    },

    prepareApplicationSizing: function () {
        var that = this;
        var applications = [];
        var _uniformCategory = ub.current_material.material.uniform_category;
        var _alias = ub.data.sportAliases.getAlias(_uniformCategory);

        _.map(ub.current_material.settings.applications, function(app) {
            if (app.status === "off") {
                return;
            }

            if (typeof app.isTailSweep !== "undefined" && app.isTailSweep) {
                return;
            }

            var obj = {};
            var appSizes = ub.funcs.getRichardsonApplicationSizes(app);

            if (typeof appSizes === "undefined") {
                appSizes = {};
                appSizes.sizes = ub.data.defaultApplicationSizes;
            }

            if (typeof app.application_size === "undefined") {
                app.application_size = "as_shown";
            }

            if (typeof app.size_type === "undefined") {
                app.size_type = "tall";
            }

            if (typeof app.notes === "undefined") {
                app.notes = "";
            }

            if (app.application_type === "team_name" || app.application_type === "player_name" || app.text_type === "text_shape") {
                obj = {
                    code: app.code,
                    type: typeof app.text_type !== "undefined" ? app.textLayoutType.replace("_", " ")  : app.application.name,
                    accent: app.accent_obj.title,
                    thumbnail: '/images/sidebar/' + app.accent_obj.thumbnail,
                    text: app.text,
                    font: app.font_obj.name,
                    colors: app.color_array,
                    isEmbellishment: false,
                    isMascot: false,
                    sizes: appSizes.sizes,
                    size_type: app.size_type,
                    application_size: app.application_size,
                    layout: typeof app.text_shape_type !== "undefined" ? app.text_shape_type : "None",
                    notes: app.notes
                };
            } else if (app.application_type === "front_number" || app.application_type === "back_number" || app.application_type === "sleeve_number") {
                obj = {
                    code: app.code,
                    type: app.application.name,
                    accent: app.accent_obj.title,
                    thumbnail: '/images/sidebar/numbers/' + app.accent_obj.thumbnail,
                    text: app.text,
                    font: app.font_obj.name,
                    colors: app.color_array,
                    isEmbellishment: false,
                    isMascot: false,
                    sizes: appSizes.sizes,
                    size_type: app.size_type,
                    application_size: app.application_size,
                    layout: false,
                    notes: app.notes
                };
            } else if (app.application_type === "embellishments" && app.text_type !== "text_shape") {
                var design_id = "";
                var design_name = "";
                var design_image = "";

                if (typeof app.embellishment !== "undefined") {
                    design_id = app.embellishment.design_id;
                    design_name = typeof app.embellishment.name !== "undefined" ? app.embellishment.name : app.embellishment.design_name;
                    design_image = app.embellishment.png_filename;

                    obj = {
                        code: app.code,
                        type: app.logo_type.toTitleCase() + " " + "logo",
                        name: design_name,
                        thumbnail: design_image,
                        details: ub.config.host + '/utilities/preview-logo-information/' + design_id,
                        isEmbellishment: true,
                        isMascot: false,
                        sizes: appSizes.sizes,
                        size_type: app.size_type,
                        application_size: app.application_size,
                        notes: app.notes,
                        vector_file: typeof app.vector_file !== "undefined" ? app.vector_file: false
                    };
                } else {
                    ub.funcs.deleteLocation(app.code);
                }
            } else if (app.application_type === "mascot") {
                obj = {
                    code: app.code,
                    type: app.logo_type + " " + "logo",
                    name: app.mascot.name,
                    thumbnail: app.mascot.icon,
                    colors: app.color_array,
                    isMascot: true,
                    sizes: appSizes.sizes,
                    size_type: app.size_type,
                    application_size: app.application_size,
                    notes: app.notes,
                    vector_file: typeof app.vector_file !== "undefined" ? app.vector_file: false
                };
            }

            applications.push(obj);

            var findApplication = RosterPanel.events.getApplicationSizingObject(app.code);

            if (typeof findApplication !== "undefined") {
                findApplication.size_type = app.size_type;
                findApplication.application_size = app.application_size;
            } else {
                ub.current_material.settings.applicationSizing.push({
                    code: app.code,
                    size_type: app.size_type,
                    application_size: app.application_size
                });
            }
        });

        var template = document.getElementById("m-richardson-application-item").innerHTML;
        var render = Mustache.render(template, {
            applications: applications,
            isNotEmpty: _.size(applications) > 0 ? true : false
        });
        
        $(".application-sizing-container table.applications-sizing-table tbody").html("");
        $(".application-sizing-container table.applications-sizing-table tbody").html(render);

        _.delay(function() {
            RosterPanel.events.setupApplicationSizing();
        }, 1000);
    },

    getApplicationSizingObject: function(code) {
        var sizing = _.find(ub.current_material.settings.applicationSizing, {code: code.toString()});
        return sizing;
    },

    setupApplicationSizing: function() {
        var sizing = ub.current_material.settings.applicationSizing;
        _.map(sizing, function(size) {
            var container = $("#richardson-team-roster .application-sizing-container table.applications-sizing-table tbody tr.application-sizing-item[data-code='"+ size.code +"']");
            container.find(".application-size-type[value='"+ size.size_type +"']").trigger("click")
            container.find("select option[value='"+ size.application_size +"']").prop("selected", true);
            if (size.application_size !== "as_shown") {
                container.find(".application-size-type-container").removeClass("uk-hidden");
            }
        });

        $(".uk-select").select2({
            minimumResultsForSearch: Infinity,
            width: 'reslove'
        });
    },

    setupRosterListingSummary: function(size, category) {
        RosterPanel.events.prepareRosterSummary();
        var roster = RosterPanel.events.find(size, category);

        if (typeof roster !== "undefined") {
            $("#richardson-team-roster .player-number-button.uk-active").removeClass("uk-active")
            _.each(roster.rosters, function(roster) {
                $("#richardson-team-roster .player-number-button[data-number='"+ roster.number +"']").removeClass("selected").addClass("uk-active");
            });
        } else {
            $("#richardson-team-roster .roster-player-list-table tbody").html("");
        }
    },

    renderSummaryRosterJersey: function() {
        var data = RosterPanel.teamRoster;
        var summary = [];
        _.each(_.sortBy(data, "order"), function(item) {
            var numbers = [];
            var totalQty = 0;

            _.each(item.rosters, function(item) {
                if (item.number.length === 0) {
                    numbers.push(false);
                } else {
                    if (item.number === "00" || item.number === "0" || item.number.startsWith("0")) {
                        numbers.push(item.number.toString());
                    } else {
                        numbers.push(parseInt(item.number));
                    }
                }

                totalQty += parseInt(item.qty);
            });

            if (item.rosters.length > 0) {
                summary.push({
                    size: item.size,
                    category: item.category,
                    numbers: _.sortBy(numbers),
                    total: totalQty
                });
            }
        });

        var template = document.getElementById("m-richardson-team-roster-jersey-summary").innerHTML;
        var render = Mustache.render(template, {
            rosters: summary,
        });

        $("#richardson-team-roster .roster-summary").html("");
        $("#richardson-team-roster .roster-summary").html(render);
    },

    renderSummaryRosterPants: function() {
        var data = RosterPanel.teamRoster;
        var summary = [];
        _.each(_.sortBy(data, "order"), function(item) {
            var inseamArr = [];
            var numbers = [];
            var totalQty = 0;

            _.each(item.rosters, function(item) {
                var findInseam = _.find(inseamArr, {inseam: item.inseam});
                if (typeof findInseam === "undefined") {
                    inseamArr.push({
                        size: item.size,
                        category: item.category,
                        inseam: item.inseam,
                        numbers: [],
                        qty: 0
                    });
                }
            });

            _.each(item.rosters, function(item) {
                var findInseam = _.find(inseamArr, {inseam: item.inseam});

                if (typeof findInseam !== "undefined") {
                    if (item.number.length === 0) {
                        findInseam.numbers.push(false);
                    } else {
                        if (item.number === "00" || item.number === "0" || item.number.startsWith("0")) {
                            findInseam.numbers.push(item.number.toString());
                        } else {
                            findInseam.numbers.push(parseInt(item.number));
                        }
                    }

                    findInseam.qty += parseInt(item.qty);
                }
            });

            if (item.rosters.length > 0) {
                summary.push({
                    inseam: inseamArr
                });
            }
        });

        var template = document.getElementById("m-richardson-team-roster-pants-summary").innerHTML;
        var render = Mustache.render(template, {
            rosters: summary,
        });

        $("#richardson-team-roster .roster-summary").html("");
        $("#richardson-team-roster .roster-summary").html(render);
    },

    renderSummaryRosterSocks: function() {
        var data = RosterPanel.teamRoster;

        var summary = [];
        _.each(_.sortBy(data, "order"), function(item) {
            var totalQty = 0;

             _.each(item.rosters, function(item) {
                totalQty += parseInt(item.qty);
            });

            if (item.rosters.length > 0) {
                summary.push({
                    category: item.category,
                    size: item.size,
                    qty: totalQty,
                });
            }
        });

        var template = document.getElementById("m-richardson-team-roster-socks-summary").innerHTML;
        var render = Mustache.render(template, {
            rosters: summary,
        });

        $("#richardson-team-roster .roster-summary").html("");
        $("#richardson-team-roster .roster-summary").html(render);
    },

    initializeRosterSummary: function(active_size, category) {
        var roster = RosterPanel.events.find(active_size, category);
        RosterPanel.events.prepareRosterList(roster.rosters);
        RosterPanel.events.prepareRosterSummary();
    },

    initializeRosterSizes: function(data) {
        var _sport = ub.config.sport;
        var _gender = ub.config.gender;

        if (ub.funcs.is_pts_sock()) {
            var _socks_youth = ub.data.sizes.getSizes(_sport, _gender, 'youth');
            var _socks_adult = ub.data.sizes.getSizes(_sport, _gender, 'adult');

            if (typeof _socks_youth !== "undefined" || typeof _socks_adult !== "undefined") {
                data.socksSizes = _.union(_socks_youth.sizes, _socks_adult.sizes);
            } else {
                data.socksSizes = _.pluck(RosterPanel.availableSizesSocks, "size");
                ub.utilities.info('No Youth & Adult Prices defined.');
            }
        } else {
            var youthSize = ub.data.sizes.getSizes(_sport, _gender, "youth");
            var adultSize = ub.data.sizes.getSizes(_sport, _gender, "adult");

            if (ub.funcs.isBaseBall() && ub.funcs.is_lower()) {
                var youthPant = _.find(RosterPanel.availableSizes, {category: "youth"});

                if (typeof youthPant !== "undefined") {
                    var youthSizes = youthPant.sizes
                    var index = _.indexOf(youthSizes, "YXS");

                    if (index !== -1) {
                        youthSizes = youthSizes.splice(0, 1);
                    }
                }
            }

            if (typeof youthSize !== "undefined") {
                var youth = _.find(RosterPanel.availableSizes, {category: "youth"});

                if (typeof youth !== "undefined") {
                    youth.sizes = youthSize.sizes;
                }
            } else {
                ub.utilities.info('No Youth Prices defined.');
            }

            if (typeof adultSize !== "undefined") {
                var adult = _.find(RosterPanel.availableSizes, {category: "adult"});

                if (typeof adult !== "undefined") {
                    adult.sizes = adultSize.sizes;
                }
            } else {
                ub.utilities.info('No Adult Prices defined.');
            }

            data.uniformSizes = RosterPanel.availableSizes;
        }
    }
};

RosterPanel.lockFunction = function() {
    $("#richardson-team-roster .roster-uniform-size-container .uniform-size-button:not(.selected)").addClass("uk-disabled");
    $("#richardson-team-roster .select-player-number-main-div").addClass("uk-disabled");
    $("#richardson-team-roster .roster-player-list-table tbody").addClass("uk-disabled");

    $("#richardson-team-roster .uk-modal-footer").addClass("uk-hidden");
    $("#richardson-team-roster .applications-sizing-table form").addClass("uk-disabled");
    $("#richardson-team-roster .applications-sizing-table textarea").addClass("uk-disabled");
}


RosterPanel.renderVectorPreview = function(element, vector_file, filename) {
    var template = _.template(document.getElementById("app-size-vector-preview").innerHTML);
    $(element).html("")
    $(element).html(template({
        vector_file: vector_file,
        filename: filename
    }));
}

RosterPanel.renderUploadVector = function(element) {
    var template = _.template(document.getElementById("app-size-upload-vector").innerHTML);
    $(element).html("")
    $(element).html(template());
}

RosterPanel.findSizeCategory = function(size) {
    var _sport = ub.config.sport;
    var _gender = ub.config.gender;

    if (ub.funcs.isSocks()) {
        var _socks_youth = ub.data.sizes.getSizes(_sport, _gender, 'youth');
        var _socks_adult = ub.data.sizes.getSizes(_sport, _gender, 'adult');
        var socksAvailableSizes = _.union(_socks_youth.sizes, _socks_adult.sizes);

        if (_.contains(socksAvailableSizes, size)) {
            return _.find(RosterPanel.availableSizesSocks, function(item) {
                if (item.size === size || item.cart === size) {
                    return item;
                }
            });
        } else {
            return;
        }
    } else {
        var youthSize = ub.data.sizes.getSizes(_sport, _gender, "youth");
        var adultSize = ub.data.sizes.getSizes(_sport, _gender, "adult");

        if (typeof youthSize !== "undefined") {
            if (_.contains(youthSize.sizes, size)) {
                return RosterPanel.findSizeInListOfAvaliableSizes(size);
            }
        }

        if (typeof adultSize !== "undefined") {
            if (_.contains(adultSize.sizes, size)) {
                return RosterPanel.findSizeInListOfAvaliableSizes(size);
            }
        }

        return RosterPanel.findSizeInListOfAvaliableSizes(size);
    }
}

RosterPanel.findSizeInListOfAvaliableSizes = function(size) {
    return _.find(RosterPanel.availableSizes, function(item) {
        if (_.contains(item.sizes, size)) {
            return item;
        }
    });
}

RosterPanel.checkTeamRosterContent = function() {
    var filter = _.filter(RosterPanel.teamRoster, function(item) {
        if (_.size(item.rosters) > 0) {
            return item;
        }
    })

    if (_.size(filter) > 0) {
        return true;
    }

    return false;
}